import { detectPageType } from './vmkQuoteTable';

export const PAGE_TYPE_ROUTES = {
  kozijnen: '/kozijnen',
  voordeur: '/voordeur',
  achterdeur: '/achterdeur',
  terrasdeur: '/terrasdeur',
  schuifpui: '/schuifpui',
  keralit: '/keralit',
};

export const getRouteForQuoteType = (type) =>
  PAGE_TYPE_ROUTES[type] || PAGE_TYPE_ROUTES.kozijnen;

export const getRouteForDrawing = (drawing) => {
  const type = drawing?.type || detectPageType(drawing?.config || {});
  return getRouteForQuoteType(type);
};

/** Normalize backend quote_data into local savedQuotes shape. */
export const normalizeBackendQuoteDrawings = (quoteData = {}) => {
  const raw =
    quoteData.drawings ||
    quoteData.savedQuotes ||
    (quoteData.config
      ? [
          {
            config: quoteData.config,
            pricing: quoteData.pricing,
            dimensions: quoteData.dimensions,
            svgData: quoteData.svgData,
            type: quoteData.type,
          },
        ]
      : []);

  return raw.map((drawing, index) => ({
    ...drawing,
    id: drawing.id || `drawing-${index}-${Date.now()}`,
    type: drawing.type || detectPageType(drawing.config || {}),
    savedAt: drawing.savedAt || new Date().toISOString(),
  }));
};

export const defaultClientDetails = () => ({
  name: '',
  address: '',
  city: '',
  postalCode: '',
  phone: '',
  email: '',
  notes: '',
  signature: '',
  subjectToFinance: false,
  clickOnColorAndSize: false,
  screenElectricallyOperated: false,
  rollerShutterElectricallyOperated: false,
  buoySharing: false,
  typesetting: false,
  container: false,
  interiorFinish: false,
  crane: false,
  craneTrips: '',
  liftingAssistance: false,
  liftingAssistancePersonnel: '',
  comments: '',
});
